<template>
  <div class="container">
    <div id="header" class="flex flex-row-left  margin-top-20 ">
      <div class="flex-item-center">
        <el-form :inline="true" :model="formInline" class="demo-form-inline">
          <el-form-item label="单号">
            <el-input type="textarea" style="width:200px" v-model="formInline.number" placeholder="请输入物流单号,换行查询多个" clearable />
          </el-form-item>
          <el-form-item label="操作类型">
            <el-select
                @clear="formInline.status=''"
                v-model="formInline.status"
                clearable
                placeholder="请选择操作类型"
                remote-show-suffix
                style="width: 200px"
            >
              <el-option
                  v-for="item in resiveList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="操作仓库">
            <el-select
                v-model="formInline.warehouseId"
                filterable
                clearable
                @clear="formInline.warehouseId=''"
                :placeholder="请选择操作仓库"
                remote-show-suffix
                class="mobile-select"
                @change="handleChange"
            >
              <el-option
                  v-for="item in stockList"
                  :key="item.warehousefCode"
                  :label="item.warehouseName"
                  :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="操作时间">
            <el-date-picker
                value-format="YYYY-MM-DD"
                format="YYYY-MM-DD"
                v-model="formInline.startMonth"
                type="date"
                placeholder="操作时间"
                clearable
                @clear="formInline.startMonth=''"
            />
            -
            <el-date-picker
                value-format="YYYY-MM-DD"
                format="YYYY-MM-DD"
                v-model="formInline.endMonth"
                type="date"
                placeholder="操作时间"
                clearable
                @clear="formInline.endMonth=''"
            />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit">查询</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="flex flex-row-right ">
      <el-button type="primary" @click="onSubmits">导出Excel</el-button>
    </div>
    <div class="margin-20-0">
      <div>
        <el-table
            :max-height="dynamicHeight"
            :data="tableData"
            :preserve-expanded-content="true"
            :stripe="true" :border="true"
            :highlight-current-row="true"
            size="default"
            row-key="id"
            :lazy="true"
            :load="load"
            :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
            empty-text="请点击查询">
          <el-table-column
              label="操作类型"
              min-width="120"
              prop="receiveStatus"
          >
            <template #default="scope">
              <span v-if="scope.row.operationType==1" >订单匹配入库</span>
              <span v-if="scope.row.operationType==2">售后仓发货</span>
              <span v-if="scope.row.operationType==3">售后仓维修出库</span>
              <span v-if="scope.row.operationType==4">售后仓维修入库</span>
<!--              <span v-if="scope.row.operationType==5">平台仓调拨出库</span>-->
              <span style="padding-left:20px" v-if="scope.row.operationType==6">手动入库单</span>
              <span :style="{paddingLeft:formInline.status!=1 ? '20px' : '0px' }" v-if="scope.row.operationType==7">订单匹配入库</span>
              <span v-if="scope.row.operationType==8">临时签收</span>
            </template>
          </el-table-column>
          <el-table-column
              label="操作号"
              min-width="100"
              prop="uniPlatformId"
          ></el-table-column>
          <el-table-column
              label="物流单号"
              min-width="100"
              prop="trackNumber"
          ></el-table-column>
          <el-table-column
              label="产品SKU"
              min-width="100"
              prop="materSku"
          ></el-table-column>
          <el-table-column
              label="产品名称"
              min-width="100"
              prop="materName"
          ></el-table-column>
          <el-table-column
              label="仓库"
              min-width="100"
              prop="warehouseName"
          ></el-table-column>
          <el-table-column
              label="操作数量"
              min-width="80"
              prop="quantity"
          ></el-table-column>
          <el-table-column
              label="SN号/操作状态"
              min-width="100"
              prop="snNumber"
          ></el-table-column>
          <el-table-column
              label="操作时间"
              min-width="80"
              prop="CreateTime"
          ></el-table-column>
          <el-table-column
              label="操作人"
              min-width="80"
              prop="operationPerson"
          ></el-table-column>
          <el-table-column
              label="备注/批次号"
              min-width="80"
              prop="remark"
          >
            <template #default="scope">
              <el-tooltip
                  class=""
                  effect="dark"
                  :content="scope.row.remark"
              >
                <span class="ellipsis-3-lines" >{{scope.row.remark}}</span>
              </el-tooltip>
            </template>

          </el-table-column>
        </el-table>
      </div>
      <div class="flex flex-row-center flex-item-center margin-10-0 pagination">
        <el-pagination v-model:current-page="currentPage"  :page-size="pageSize" :total="pageTotal" :page-sizes="[10, 20, 30, 50]" @size-change="handleSizeChange"
                       @current-change="handleCurrentChange" background layout="total, sizes, prev, pager, next,"  />
      </div>
    </div>
  </div>
</template>
<script>
import {ElForm,ElFormItem,ElButton,ElInput,ElDatePicker,ElTable,ElTooltip,

  ElTableColumn,ElPagination,ElSelect,ElOption} from "element-plus";

import {operationLog,operationLogItem, operationLogItems} from "@/utils/api";
import {baseUrl}  from "../../../src/utils/requset.js"
import DynamicHeightMixin from "../../../public/js/dynamicHeightMixin";
import {getLocalStockList} from "../../../public/js";

export default {
  name: "operationLog",
  mixins:[DynamicHeightMixin],
  components: {ElForm,ElFormItem,ElButton,ElInput,ElDatePicker,ElTable,ElSelect,ElOption,ElTooltip,
    ElTableColumn,ElPagination},
  data(){
    return{
      formInline:{},
      resiveList:[
          {label:"订单匹配入库",value:1},
          {label:"售后仓发货",value:2},
          {label:"售后仓维修出库",value:3},
          {label:"售后仓维修入库",value:4},
          // {label:"平台仓调拨出库",value:5},
          {label:"手动入库单",value:6},
          // {label:"订单匹配入库",value:7},
          {label:"临时签收",value:8}
      ],
      tableData:[],
      stockList:[],
      currentPage:1,
      pageTotal:0,
      pageSize:20,
    }
  },
  beforeMount() {
    // 是否启用自动查询
    // this.getReceipt();
    this.getLocalStockList()
  },
  methods:{
    load(node,treeNode, resolve){
      if(node.operationType==8){
        operationLogItem({number:node.uniPlatformId}).then(res=>{
          console.log(res.Data.data)
          resolve(res.Data.data)
        }).catch(res=>{
          console.log(res)
        })
      }
      if(node.operationType==3){
        operationLogItems({number:node.uniPlatformId}).then(res=>{
          console.log(res.Data.data)
          resolve(res.Data.data)
        }).catch(res=>{
          console.log(res)
        })
      }
    },
    getLocalStockList(){
      getLocalStockList().then(res => {
        this.stockList = res.filter(item=>{
          return item.warehouseName.includes("美国售后仓")
        })
      })
    },
    onSubmit(){
      this.PageNumber = 1
      this.getReceipt()
    },
    onSubmits(){
      let pramas = Object.entries(this.formInline)
          .map(([k, v]) => `${k}=${encodeURIComponent(v)}`)
          .join('&');
      let url = baseUrl + 'after/operationLogExcel?'+ pramas

      window.open(url)
    },
    handleSizeChange(val){
      this.pageSize = val;
      this.getReceipt();
    },
    handleCurrentChange(val){
      this.currentPage = val;
      this.getReceipt();
    },
    getReceipt(){
      operationLog({...this.formInline,PageSize:this.pageSize,PageNumber:this.currentPage}).then(res=>{
        this.tableData = res.Data.data
        this.pageTotal = res.Data.count
      }).catch(res=>{
        console.log(res)
      })
    },
  }
}
</script>
<style scoped>
.container{
  width: 92%;
  margin:0 auto;
}
::v-deep .container {
  .el-form-item{
    margin-bottom:0!important;
  }
}
::v-deep .el-table .el-table__cell{
  box-sizing: border-box;
  min-width: 0;
  padding: 8px 0;
  position: relative;
  text-align: left;
  text-overflow: ellipsis;
  vertical-align: middle;
  z-index: unset !important;
}
.pagination{
  margin: 20px auto;
  display: flex;
  justify-content: center;
  align-items: center;
}
::v-deep .el-button+.el-button {
  margin-left: 0px;
}
</style>